/**
 * Changelog data module.
 * The source of truth is `changelog.json` in this directory.
 * Update that file to add new release notes — no need to touch this file.
 *
 * The LATEST_VERSION is derived from the JSON file (first entry),
 * and should match the version in package.json.
 */
import rawChangelog from './changelog.json';

export type ChangelogCategory = 'feature' | 'improvement' | 'fix' | 'security';

export interface ChangelogItem {
  category: ChangelogCategory;
  titleKey: string;
  descriptionKey: string;
}

export interface ChangelogEntry {
  version: string;
  date: string;
  items: ChangelogItem[];
}

// Normalize the JSON shape (entries -> items)
export const CHANGELOG: ChangelogEntry[] = rawChangelog.map((entry) => ({
  version: entry.version,
  date: entry.date,
  items: (entry.entries as ChangelogItem[]) ?? [],
}));

export const LATEST_VERSION = CHANGELOG[0]?.version ?? '0.0.0';
export const LATEST_VERSION_DATE = CHANGELOG[0]?.date ?? '';
